<template>
  <v-app>
    <v-container fluid>
      <v-row><v-col cols="12">
        <v-expansion-panels v-model="panel"><v-expansion-panel>
          <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form</v-expansion-panel-title>
          <v-expansion-panel-text><v-form @submit.prevent="submit"><v-row class="pa-2">
            <v-col lg="3" md="3" cols="12">
              <v-autocomplete v-model="warehouse_id.value.value" label="Warehouse" bg-color="grey-lighten-4" variant="outlined" density="compact" :items="getWarehouseList" item-title="name" item-value="id" clearable hide-details class="py-1"  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
              <v-autocomplete v-model="supplier_id.value.value" label="Supplier" bg-color="grey-lighten-4" variant="outlined" density="compact" :items="getSupplierList" item-title="supplier_name" item-value="id" clearable hide-details class="py-1"  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <v-autocomplete v-model="product_id.value.value" label="Product" bg-color="grey-lighten-4" variant="outlined" density="compact" :items="getProductMapList" :item-title="(item) => item?.product?.name" item-value="product_id" clearable hide-details class="py-1"  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
              <v-select v-model="approval_status.value.value" label="Approval Status" bg-color="grey-lighten-4" variant="outlined" density="compact" :items="approvalStatuses" item-title="title" item-value="value" clearable hide-details class="py-1"  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <v-date-input input-format="dd/mm/yyyy" v-model="from_date.value.value" label="From Date" bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month" variant="outlined" density="compact" clearable hide-details class="py-1" />
              <v-btn class="bg-brand my-1" type="submit" :loading="loading">Search</v-btn>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <v-date-input input-format="dd/mm/yyyy" v-model="to_date.value.value" label="To Date" bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month" variant="outlined" density="compact" clearable hide-details class="py-1" />
            </v-col>
          </v-row></v-form></v-expansion-panel-text>
        </v-expansion-panel></v-expansion-panels>
      </v-col></v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;"><v-row><v-col cols="12">
      <v-expansion-panels v-model="panel"><v-expansion-panel>
        <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Direct Receive Report</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row class="py-2"><v-col md="4" cols="12"><v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" hide-details density="compact" variant="outlined" clearable /></v-col>
            <v-col md="4" cols="12" class="d-flex justify-center"><v-btn-group variant="outlined" density="compact" size="x-small" divided>
              <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
              <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
              <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
            </v-btn-group></v-col></v-row>
          <v-data-table :headers="reportHeaders" :items="reports?.data || []" :loading="loading" v-model:items-per-page="itemsPerPage" :search="search" hover density="compact">
            <template #item.receive_qty="{ item }">{{ formatNumber(item.receive_qty) }}</template>
            <template #item.sales_rate="{ item }">{{ formatNumber(item.sales_rate) }}</template>
            <template #item.purchase_rate="{ item }">{{ formatNumber(item.purchase_rate) }}</template>
            <template #item.amount="{ item }">{{ formatNumber(item.amount) }}</template>
            <template #item.total_amount="{ item }">{{ formatNumber(item.total_amount) }}</template>
            <template #body.append><tr class="font-weight-bold bg-grey-lighten-4"><td v-for="header in reportHeaders" :key="header.key" class="text-end px-1">{{ header.key === "sl" ? "Total" : reports?.summary?.[header.key] ?? "" }}</td></tr></template>
          </v-data-table>
        </v-expansion-panel-text>
      </v-expansion-panel></v-expansion-panels>
    </v-col></v-row></v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter.js";

export default {
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    approvalStatuses: [
      { title: "Pending", value: "Pending" },
      { title: "Approved", value: "Approved" },
      { title: "Rejected", value: "Rejected" },
    ],
    headers: [
      { title: "SL", key: "sl", align: "center", sortable: false },
      { title: "Direct Receive No.", key: "direct_receive_no", sortable: false },
      { title: "Receive Date", key: "receive_date", sortable: false },
      { title: "Supplier Name", key: "supplier_name", sortable: false },
      { title: "Source Date", key: "source_date", sortable: false },
      { title: "Source Address", key: "source_address", sortable: false },
      { title: "Warehouse", key: "warehouse", sortable: false },
      { title: "Item Code", key: "item_code", sortable: false },
      { title: "Item Name", key: "item_name", sortable: false },
      { title: "Lot No.", key: "lot_no", sortable: false },
      { title: "Batch No.", key: "batch_no", sortable: false },
      { title: "Receive Qty.", key: "receive_qty", align: "end", sortable: false },
      { title: "UOM", key: "uom", sortable: false },
      { title: "Sales Rate", key: "sales_rate", align: "end", sortable: false },
      { title: "Purchase Rate", key: "purchase_rate", align: "end", sortable: false },
      { title: "Amount", key: "amount", align: "end", sortable: false },
      { title: "Total Amount", key: "total_amount", align: "end", sortable: false },
      { title: "Approved By", key: "approved_by", sortable: false },
      { title: "Approval Status", key: "approval_status", sortable: false },
      { title: "Issue Status", key: "issue_status", sortable: false },
      { title: "Remarks", key: "remarks", sortable: false },
    ],
  }),
  computed: {
    reportHeaders() {
      const columns = this.reports?.columns;
      if (!Array.isArray(columns) || !columns.length) return this.headers;
      return columns.map(({ field, label }) => ({ title: label, key: field, align: field === "sl" ? "center" : "start", sortable: false }));
    },
    getWarehouseList() { return this.$store.getters.getWarehouseList || []; },
    getSupplierList() { return this.$store.getters.getSupplierList || []; },
    getProductMapList() { return (this.$store.getters.getProductMapList || []).filter((item) => item.branch_id == this.$store.getters.getAuthUser.branch_id && item.status == 1); },
  },
  created() {
    if (!this.getWarehouseList.length) this.$store.dispatch("getWarehouseList");
    if (!this.getSupplierList.length) this.$store.dispatch("getSupplierList", {});
    if (!this.getProductMapList.length) this.$store.dispatch("getProductMapList");
  },
  setup() {
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });
    const warehouse_id = useField("warehouse_id"), supplier_id = useField("supplier_id");
    const product_id = useField("product_id"), approval_status = useField("approval_status");
    const from_date = useField("from_date"), to_date = useField("to_date");
    const store = useStore(), loading = ref(false), reports = ref({});
    const submit = handleSubmit((values) => {
      loading.value = true;
      store.dispatch("getInvDirectReceiveReport", { ...values, from_date: formattedDate(values.from_date), to_date: formattedDate(values.to_date) })
        .then((response) => { reports.value = response.data; })
        .catch((error) => toast.error(error.response?.data?.message || "Unable to load report"))
        .finally(() => { loading.value = false; });
    });
    return { warehouse_id, supplier_id, product_id, approval_status, from_date, to_date, loading, reports, submit };
  },
  methods: {
    formatNumber(value) { return value == null ? "" : Number(value).toFixed(2); },
    exportRows() { return [this.reportHeaders.map((header) => header.title), ...(this.reports?.data || []).map((item) => this.reportHeaders.map((header) => item[header.key] ?? ""))]; },
    exportToCSV() { this.$exportTableToCSV(this.exportRows(), `direct_receive_report_${this.$fileDate()}`); },
    exportToExcel() { this.$exportTableToExcel(this.exportRows(), `direct_receive_report_${this.$fileDate()}`); },
    exportToPDF() { this.$exportTableToPDF(this.reportHeaders.map((header) => header.title), (this.reports?.data || []).map((item) => this.reportHeaders.map((header) => item[header.key] ?? "")), "Direct Receive Report", `direct_receive_report_${this.$fileDate()}`); },
  },
  mounted() {
    const date = new Date(), futureDate = new Date();
    futureDate.setDate(date.getDate() + 30);
    this.from_date.value.value = date;
    this.to_date.value.value = futureDate;
  },
};
</script>
